import React from 'react';
import { PictoProps } from './index';

export const Phone = (props: PictoProps) => (
  <svg
    width={props.width || '22'}
    height={props.height || '23'}
    viewBox="0 0 22 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.8881 16.5718V19.5718C20.8904 20.135 20.6552 20.673 20.2402 21.0537C19.8252 21.4344 19.269 21.6225 18.7081 21.5718C15.631 21.2375 12.6751 20.186 10.0781 18.5018C7.66195 16.9665 5.61346 14.918 4.07812 12.5018C2.3881 9.89304 1.33637 6.92283 1.00812 3.83183C0.957597 3.2727 1.1444 2.71808 1.52289 2.30345C1.90138 1.88882 2.43672 1.65236 2.99812 1.65183H5.99812C7.00199 1.64195 7.85762 2.3778 7.99812 3.37183C8.12475 4.3319 8.35957 5.27456 8.69812 6.18183C8.97286 6.91271 8.79714 7.73664 8.24812 8.29183L6.97812 9.56183C8.40168 12.0654 10.4746 14.1383 12.9781 15.5618L14.2481 14.2918C14.8033 13.7428 15.6272 13.5671 16.3581 13.8418C17.2654 14.1804 18.2081 14.4152 19.1681 14.5418C20.1737 14.6837 20.9133 15.5566 20.8881 16.5718Z"
      stroke="#004653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
